import { RouteComponentProps } from "@gatsbyjs/reach-router";

export default function LoginSuccessPage(props: RouteComponentProps) {
    return (
        <div>LoginSuccessPage</div>
    )
}
